import { Component, OnInit } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { ModalService } from '../modal.service';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material';

export enum ModalType {
  ERROR,
  MESSAGE
}

@Component({
  selector: 'mc-modal',
  templateUrl: './mc-modal.component.html',
  styleUrls: ['./mc-modal.component.scss']
})
export class McModalComponent implements OnInit {
  title: string;
  message: string;

  settings?: { okText?: string, cancelText?: string, type?: ModalType } = {
    okText: 'Ok',
    type: ModalType.MESSAGE
  };

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/modal/mc-modal/mc-modal.component.ts